"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ContextMenu;
var _react = _interopRequireWildcard(require("react"));
var _reactKonva = require("react-konva");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ContextMenu(_ref) {
  var config = _ref.config,
    onSelect = _ref.onSelect;
  var menuRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    hoveredIndex = _useState2[0],
    setHoveredIndex = _useState2[1];
  var enabled = config.enabled,
    _config$position = config.position,
    position = _config$position === void 0 ? {
      x: 0,
      y: 0
    } : _config$position;
  if (!enabled) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  if (enabled === true && menuRef.current) {
    menuRef.current.moveToTop();
  }
  var items = [{
    id: null,
    label: "Done"
  }, {
    id: "Circle",
    label: "Point"
  }, {
    id: "Line",
    label: "Line"
  }, {
    id: "Rect",
    label: "Box"
  }, {
    id: "Ellipse",
    label: "Ellipse"
  }];
  var isHovering = function isHovering(index) {
    setHoveredIndex(index);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactKonva.Group, {
    ref: menuRef,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactKonva.Rect, {
      x: position.x,
      y: position.y,
      width: 150,
      height: items.length * 30 + 10,
      fill: "#f0f0f0",
      cornerRadius: 5
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactKonva.Group, {
      children: items.map(function (_ref2, index) {
        var id = _ref2.id,
          label = _ref2.label;
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactKonva.Rect, {
            x: position.x,
            y: position.y + index * 30 + 10,
            width: 150,
            height: 30,
            fill: hoveredIndex === index ? "#999" : "transparent"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactKonva.Text, {
            x: position.x + 10,
            y: position.y + index * 30 + 10 + (30 - 16) / 2 // vertically center the text
            ,
            text: label,
            fontSize: 16,
            fill: hoveredIndex === index ? "#fff" : "#333",
            onMouseEnter: function onMouseEnter() {
              return isHovering(index);
            },
            onMouseLeave: function onMouseLeave() {
              return isHovering(null);
            },
            onMouseDown: function onMouseDown() {
              return onSelect(id);
            }
          })]
        }, index);
      })
    })]
  });
}